/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class SampleLogProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the SampleLog by ID
	 * @param {String|Number} pSampleLogID - The SampleLog ID to search for
	 * @return {Promise<any>}
	 * @async
	 */
	getSampleLogByID(pSampleLogID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pSampleLogID)
			{
				this.pict.log.error('No SampleLog ID provided.');
				return reject(new Error('No SampleLog ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`SampleLog/${pSampleLogID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLog: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the SampleLogs by an IDSample
     * @param {Object} pIDSample - The IDSample to search for
	 * @return {Promise<Array<any>>}
	 * @async
	 */
	getSampleLogsByIDSample(pIDSample)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pIDSample)
			{
				this.pict.log.error('No IDSample provided.');
				return reject(new Error('No IDSample provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`SampleLogs/FilteredTo/FBV~IDSample~EQ~${pIDSample}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting SampleLogs for IDSample ${pIDSample}: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Get the SampleLogs
	 * @return {Promise<Array<any>>}
	 * @async
	 * @example
	 */
	getSampleLogs()
	{
		return new Promise((resolve, reject) =>
		{
			let tmpURL = 'SampleLogs';

			// Filter by customer if IDCustomer is present
			if (this.pict.AppData?.DocumentData?.ReportData?.IDCustomer)
			{
				tmpURL = `SampleLogs/By/IDCustomer/${this.pict.AppData?.DocumentData?.ReportData?.IDCustomer}`;
			}

			this.pict.HeadlightRestClient.getJSON(tmpURL, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error('Failed to get SampleLogs list.', pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}

	/**
	 * Create a new sample log entry for a given sample
	 * @param {Object} pOptions - The options to use when adding the log
	 * @return {Promise<any>}
	 * @async
	 */
	async createSampleLog(pOptions)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pOptions?.IDSample)
			{
				this.pict.log.error('No Sample ID provided.');
				return reject(new Error('No Sample ID provided.'));
			}
			if (!pOptions?.Notes)
			{
				this.pict.log.error('No Log Entry provided.');
				return reject(new Error('No Log Entry provided.'));
			}
			const tmpOptions = {
				IDSample: pOptions?.IDSample || 0,
				Notes: pOptions?.Notes || '',
				CaptureDate: pOptions?.CaptureDate || new Date().toISOString(),
				CaptureLatitude: pOptions?.CaptureLatitude || 0,
				CaptureLongitude: pOptions?.CaptureLongitude || 0,
				IDLab: pOptions?.IDLab || 0,
			};

			this.pict.HeadlightRestClient.postJSON(`SampleLog`, tmpOptions, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error adding Sample Log Entry: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = SampleLogProvider;
module.exports.default_configuration = {};
